import { createAction, Dispatch } from '@reduxjs/toolkit';
import i18next from 'i18next';
import api from '../../../api';
import { Toaster } from '../../shared/component/toaster';
import { validateEntryForm } from '../../validation';

export const FILE_UPDATE = 'FILE_UPDATE';
export const FILE_FETCH = 'FILE_FETCH';
export const FILE_SUBMIT = 'FILE_SUBMIT';
export const FILE_LOADING = 'FILE_LOADING';
export const FILE_DELETE = 'FILE_DELETE';
export const FILE_WITHDRAW = 'FILE_WITHDRAW';
export const FILE_SUBMIT_NOTIFICATIONS = 'FILE_SUBMIT_NOTIFICATIONS';
export const FILE_SUBMIT_NEW_DOCUMENTS = 'FILE_SUBMIT_NEW_DOCUMENTS';

export const loadingAction = createAction<{ isLoading: boolean }>(FILE_LOADING);

export async function getEntryForm(id: string, dispatch: any) {
  try {
    dispatch(loadingAction({ isLoading: true }));

    const response = await api.entryForm.get(id);

    dispatch({ type: FILE_FETCH, payload: response.data });

    dispatch(validateEntryForm(response.data));
  } catch (error) {
    console.log(error);
    dispatch(loadingAction({ isLoading: false }));
  }
}

export async function submitEntryForm(id: string, dispatch: Dispatch) {
  try {
    dispatch(loadingAction({ isLoading: true }));

    const response = await api.entryForm.submit(id);

    dispatch({ type: FILE_SUBMIT, payload: response.data });

    Toaster.success(i18next.t('notifications.success.update'));
  } catch (error) {
    console.log(error);
    dispatch(loadingAction({ isLoading: false }));
  }
}

export async function deleteEntryForm(id: string, dispatch: Dispatch, navigate: any) {
  try {
    dispatch(loadingAction({ isLoading: true }));

    const response = await api.entryForm.delete(id);

    dispatch({ type: FILE_DELETE, payload: response.data });
    Toaster.success(i18next.t('notifications.success.delete'));
    navigate('/files');
  } catch (error) {
    console.log(error);
    dispatch(loadingAction({ isLoading: false }));
  }
}

export async function withdrawEntryForm(id: string, dispatch: Dispatch) {
  try {
    dispatch(loadingAction({ isLoading: true }));

    const response = await api.entryForm.withdraw(id);

    dispatch({ type: FILE_WITHDRAW, payload: response.data });

    Toaster.success(i18next.t('notifications.success.update'));
  } catch (error) {
    console.log(error);
    dispatch(loadingAction({ isLoading: false }));
  }
}

export async function submitNotifications(id: string, dispatch: Dispatch) {
  try {
    dispatch(loadingAction({ isLoading: true }));

    const response = await api.entryForm.submitNotifications(id);

    dispatch({ type: FILE_SUBMIT_NOTIFICATIONS, payload: response.data });

    Toaster.success(i18next.t('notifications.success.update'));
  } catch (error) {
    console.log(error);
    dispatch(loadingAction({ isLoading: false }));
  }
}

export async function submitNewDocuments(id: string, dispatch: Dispatch) {
  try {
    dispatch(loadingAction({ isLoading: true }));

    const response = await api.entryForm.submitNewDocuments(id);

    dispatch({ type: FILE_SUBMIT_NEW_DOCUMENTS, payload: response.data });

    Toaster.success(i18next.t('entryForm.actions.submitNewDocuments.success'));
  } catch (error) {
    dispatch(loadingAction({ isLoading: false }));
  }
}

export async function update(id: string, dispatch: any, formValues: any) {
  try {
    dispatch(loadingAction({ ...formValues, isLoading: true }));

    const response = await api.entryForm.update(id, formValues);

    dispatch({ type: FILE_UPDATE, payload: response.data });

    Toaster.success(i18next.t('notifications.success.update'));

    dispatch(validateEntryForm(response.data));
  } catch (error) {
    console.log(error);
    dispatch(loadingAction({ isLoading: false }));
  }
}

export async function refresh(id: string, dispatch: any) {
  try {
    dispatch(loadingAction({ isLoading: true }));
    const response = await api.entryForm.get(id);
    dispatch({ type: FILE_FETCH, payload: response.data });
    Toaster.success(i18next.t('notifications.success.update'));

    dispatch(validateEntryForm(response.data));
  } catch (error) {
    console.log(error);
    dispatch(loadingAction({ isLoading: false }));
  }
}
